import { ColumnDef } from "@tanstack/react-table";
import { Client } from "../../users.type";
import { SortUser } from "../users-table/sort-user";

export const clientColumns = (handleClientDetails: (clientId: string) => void): ColumnDef<Client>[] => [
  {
    id: "lastName",
    accessorKey: "lastName",
    header: ({ column }) => SortUser("Nom", column),
    cell: ({ row }) => {
      const client = row.original;
      return (
        <div className="flex items-center gap-3 cursor-pointer">
          <div className="flex flex-col">
            <button
              onClick={() => handleClientDetails(client.id)}
              className="cursor-pointer bg-transparent border-none p-0 text-left"
              type="button"
            >
              <span className="font-medium">{`${client?.firstName || ""} ${client?.lastName || ""}`}</span>
            </button>
          </div>
        </div>
      );
    },
  },
  {
    id: "email",
    accessorKey: "email",
    header: ({ column }) => SortUser("Email", column),
  },
  {
    id: "phoneNumber",
    accessorKey: "phoneNumber",
    header: ({ column }) => SortUser("Phone", column),
    cell: ({ row }) => row.original.phoneNumber ?? "-",
  },
  {
    id: "lastLoginDate",
    accessorKey: "lastLoginDate",
    header: ({ column }) => SortUser("Last login", column),
    cell: ({ row }) => {
      const date = row.original.lastLoginDate;
      return date ? new Date(date).toLocaleString() : "-";
    },
  },
];
